import Reader from "./Reader.vue";
import ReaderWidget from './ReaderWidget.vue';
import DefaultModeReader from './DefaultModeReader.vue';

export default ReaderWidget;

export {
  Reader,
  DefaultModeReader,
};
